function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimerRed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.032,2.074L10.032,-0.214L19.186,-0.214L19.186,2.074L10.032,2.074ZM13.464,19.123L15.753,19.123L15.753,10.351L13.464,10.351L13.464,19.123ZM14.609,31.786C12.727,31.786 10.954,31.423 9.288,30.699C7.623,29.974 6.167,28.989 4.921,27.743C3.675,26.497 2.69,25.041 1.965,23.376C1.24,21.71 0.878,19.937 0.878,18.055C0.878,16.173 1.24,14.4 1.965,12.734C2.69,11.069 3.675,9.613 4.921,8.367C6.167,7.121 7.623,6.136 9.288,5.411C10.954,4.687 12.727,4.324 14.609,4.324C16.312,4.324 17.914,4.61 19.414,5.183C20.915,5.755 22.25,6.549 23.419,7.566L25.364,5.621L26.966,7.223L25.021,9.168C25.936,10.185 26.718,11.419 27.367,12.868C28.015,14.317 28.339,16.046 28.339,18.055C28.339,19.937 27.977,21.71 27.252,23.376C26.528,25.041 25.542,26.497 24.296,27.743C23.05,28.989 21.595,29.974 19.929,30.699C18.264,31.423 16.49,31.786 14.609,31.786ZM14.609,29.497C17.787,29.497 20.489,28.385 22.714,26.16C24.938,23.935 26.051,21.233 26.051,18.055C26.051,14.877 24.938,12.175 22.714,9.95C20.489,7.725 17.787,6.613 14.609,6.613C11.43,6.613 8.729,7.725 6.504,9.95C4.279,12.175 3.166,14.877 3.166,18.055C3.166,21.233 4.279,23.935 6.504,26.16C8.729,28.385 11.43,29.497 14.609,29.497Z",
    style: {
      fill: "#f00",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimerRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/timer-red.442de7856e918e70cce4708a0ad35174.svg";